import { CSSProperties, ReactNode } from "react";
import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_PRIMARY_COLOR,
} from "../note-preview-constant";

export interface ReportSectionTabProps {
  label: string;
  children?: ReactNode;
  style?: CSSProperties;
}

/** Blue tab heading with a rule beneath it, followed by the section body. */
const ReportSectionTab = ({
  label,
  children,
  style,
}: ReportSectionTabProps) => (
  <section style={{ marginTop: 10, ...style }}>
    <div
      style={{
        borderBottom: `2px solid ${NOTE_PREVIEW_PRIMARY_COLOR}`,
        breakAfter: "avoid",
      }}
    >
      <span
        style={{
          display: "inline-block",
          padding: "2px 12px 1px 8px",
          background: NOTE_PREVIEW_PRIMARY_COLOR,
          color: "#FFFFFF",
          fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
          fontWeight: 600,
          borderRadius: "4px 12px 0 0",
        }}
      >
        {label}
      </span>
    </div>
    <div style={{ padding: "6px 2px 2px" }}>{children}</div>
  </section>
);

export default ReportSectionTab;
